import { forwardRef, type SVGProps } from "react";

export const GiftBoxGraphicIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(({ "aria-hidden": ariaHidden = true, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={ariaHidden}
      {...props}
    >
      <title>Gift box</title>
      <path
        d="M35.856 41.9948V28.963L23.4826 23.6291V36.6609L35.856 41.9948Z"
        fill="#94B9F6"
      />
      <path
        d="M5.625 15.9312V28.963L8.50415 30.2041L19.157 34.7963V21.7645L5.625 15.9312Z"
        fill="#94B9F6"
      />
      <path
        d="M23.4826 23.6291L35.856 28.963L48.3474 23.6291L35.856 18.1976L23.4826 23.6291Z"
        fill="#B3CEFA"
      />
      <path
        d="M17.518 12.1418L5.625 15.9312L19.157 21.7645L26.6428 18.1976C23.7339 17.6772 18.8862 15.7147 17.518 12.1418Z"
        fill="#B3CEFA"
      />
      <path
        d="M21.7396 10.7968C22.9782 13.1496 28.9814 14.6492 32.1132 14.7978C30.6303 12.8521 28.4579 10.6543 26.4641 9.29145L21.7396 10.7968Z"
        fill="#B3CEFA"
      />
      <path
        d="M40.5408 7.77755L35.856 6.29899L31.4307 7.709C33.084 9.09319 34.614 10.6179 35.856 11.9648C37.0617 10.7028 38.7006 9.18443 40.5408 7.77755Z"
        fill="#B3CEFA"
      />
      <path
        d="M41.0385 14.7978C44.0994 14.3775 49.4011 13.0775 51.1351 11.1213L46.4127 9.63082C44.4457 11.0489 42.3835 13.1549 41.0385 14.7978Z"
        fill="#B3CEFA"
      />
      <path
        d="M53.1309 21.5865L66.375 15.9312L55.3919 12.4648C53.4859 15.4054 49.2096 17.4918 46.221 18.1976L53.1309 21.5865Z"
        fill="#B3CEFA"
      />
      <path
        d="M35.856 41.9948L48.4519 36.6163L48.3474 23.6291L35.856 28.963V41.9948Z"
        fill="#709ADF"
      />
      <path
        d="M66.375 28.963V15.9312L53.1309 21.5865V34.6183L63.4959 30.1924L66.375 28.963Z"
        fill="#709ADF"
      />
      <path
        d="M53.1309 21.5865L48.3474 23.6291L48.4519 36.6163L53.1309 34.6183V21.5865Z"
        fill="#246CE1"
      />
      <path
        d="M53.1309 61.1884V37.5541V34.6183L48.4519 36.6163L48.4754 39.5385L48.6651 63.1108L53.1309 61.1884Z"
        fill="#246CE1"
      />
      <path
        d="M23.4826 23.6291L19.157 21.7645V34.7963L23.4826 36.6609V23.6291Z"
        fill="#367EF4"
      />
      <path
        d="M19.157 61.3606L23.4826 63.2423V39.5877V36.6609L19.157 34.7963V37.7246V61.3606Z"
        fill="#367EF4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.157 21.7645L23.4826 23.6291L35.856 18.1976L48.3474 23.6291L53.1309 21.5865L46.221 18.1976C49.2096 17.4918 53.4859 15.4054 55.3919 12.4648C56.5461 10.6839 56.8311 8.58966 55.4342 6.29899C52.143 0.901802 45.5855 3.92076 40.5408 7.77755C38.7006 9.18443 37.0617 10.7028 35.856 11.9648C34.614 10.6179 33.084 9.09319 31.4307 7.709C26.8241 3.85245 21.2727 1.5625 18.2932 6.29899C16.8916 8.52725 16.9 10.528 17.518 12.1418C18.8862 15.7147 23.7339 17.6772 26.6428 18.1976L19.157 21.7645ZM32.1132 14.7978C28.9814 14.6492 22.9782 13.1496 21.7396 10.7968C21.3831 10.1196 21.4213 9.37181 22.0361 8.56519C22.8732 7.46706 24.5897 8.01026 26.4641 9.29145C28.4579 10.6543 30.6303 12.8521 32.1132 14.7978ZM51.1351 11.1213C49.4011 13.0775 44.0994 14.3775 41.0385 14.7978C42.3835 13.1549 44.4457 11.0489 46.4127 9.63082C48.5161 8.11442 50.5108 7.38454 51.4034 8.84849C51.9101 9.67935 51.7389 10.4401 51.1351 11.1213Z"
        fill="#478BFB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.856 68.625V44.9174L48.4754 39.5385L48.6651 63.1108L35.856 68.625Z"
        fill="#709ADF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.4959 33.1361V56.7264L53.1309 61.1884V37.5541L63.4959 33.1361Z"
        fill="#709ADF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.856 44.9174L23.4826 39.5877V63.2423L35.856 68.625V44.9174Z"
        fill="#94B9F6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.50415 56.7264V33.1361L19.157 37.7246V61.3606L8.50415 56.7264Z"
        fill="#94B9F6"
      />
      <path
        d="M19.157 34.7963L8.50415 30.2041V33.1361L19.157 37.7246V34.7963Z"
        fill="#709ADF"
      />
      <path
        d="M35.856 41.9948L23.4826 36.6609V39.5877L35.856 44.9174V41.9948Z"
        fill="#709ADF"
      />
      <path
        d="M48.4519 36.6163L35.856 41.9948V44.9174L48.4754 39.5385L48.4519 36.6163Z"
        fill="#5C84C6"
      />
      <path
        d="M63.4959 30.1924L53.1309 34.6183V37.5541L63.4959 33.1361V30.1924Z"
        fill="#5C84C6"
      />
    </svg>
  );
});
GiftBoxGraphicIcon.displayName = "GiftBoxGraphicIcon";

interface GiftBoxIconProps extends SVGProps<SVGSVGElement> {
  color?: string;
  title?: string;
}

export const GiftBoxIcon = forwardRef<SVGSVGElement, GiftBoxIconProps>(
  ({ color = "white", title = "Gift box", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        {...props}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>{title}</title>
        <path
          d="M9.0625 18.0576V5.83594C9.0625 5.31817 9.48223 4.89844 10 4.89844C10.5178 4.89844 10.9375 5.31817 10.9375 5.83594V18.0576C10.9375 18.5754 10.5178 18.9951 10 18.9951C9.48223 18.9951 9.0625 18.5754 9.0625 18.0576Z"
          fill={color}
        />
        <path
          d="M6.11127 1.00781C8.03048 1.00787 9.24971 2.3145 9.92719 3.3894C10.2754 3.94204 10.5173 4.48795 10.6718 4.89087C10.7495 5.09352 10.8068 5.264 10.8452 5.38647C10.8644 5.44782 10.8789 5.49841 10.8891 5.53418C10.8941 5.55189 10.8984 5.56617 10.9013 5.5769C10.9028 5.5823 10.904 5.58678 10.905 5.59033C10.9054 5.59211 10.9058 5.59392 10.9062 5.59521L10.9074 5.59644V5.59766L10.9282 5.70386C10.9631 5.95241 10.8967 6.206 10.7414 6.40698C10.5639 6.63653 10.2906 6.77185 10.0004 6.77197H6.11127C4.52021 6.77197 3.22926 5.48093 3.22919 3.88989C3.22919 2.29879 4.52017 1.00781 6.11127 1.00781ZM5.10419 3.88989C5.10426 4.4454 5.55575 4.89697 6.11127 4.89697H8.62469C8.54119 4.73177 8.44859 4.55912 8.34149 4.38916C7.79367 3.51986 7.06821 2.88287 6.11127 2.88281C5.5557 2.88281 5.10419 3.33433 5.10419 3.88989Z"
          fill={color}
        />
        <path
          d="M14.8963 3.88989C14.8963 3.33442 14.4446 2.88296 13.8892 2.88281C12.9322 2.88281 12.2068 3.51991 11.659 4.38916C11.5518 4.55923 11.4581 4.73167 11.3745 4.89697H13.8892C14.4446 4.89683 14.8962 4.44531 14.8963 3.88989ZM16.7713 3.88989C16.7712 5.48084 15.4801 6.77183 13.8892 6.77197H10C9.70974 6.77197 9.43537 6.63664 9.25783 6.40698C9.08065 6.1774 9.01998 5.87833 9.09304 5.59766V5.59521C9.09337 5.59397 9.09381 5.59202 9.09426 5.59033C9.09519 5.58683 9.09648 5.58221 9.09792 5.5769C9.10083 5.56621 9.10511 5.55179 9.11013 5.53418C9.12032 5.49841 9.13486 5.44782 9.15407 5.38647C9.19242 5.26402 9.24967 5.09357 9.32741 4.89087C9.48197 4.48794 9.72378 3.94208 10.072 3.3894C10.7495 2.3144 11.9697 1.00781 13.8892 1.00781C15.4802 1.00796 16.7713 2.29888 16.7713 3.88989Z"
          fill={color}
        />
        <path
          d="M3.22919 15.8342V9.16797C3.22919 8.6502 3.64892 8.23047 4.16669 8.23047C4.68445 8.23047 5.10419 8.6502 5.10419 9.16797V15.8342C5.10419 16.5441 5.67861 17.1193 6.38837 17.1196H13.6113C14.3212 17.1196 14.8954 16.5442 14.8954 15.8342V9.16797C14.8954 8.65034 15.3154 8.23069 15.8329 8.23047C16.3507 8.23047 16.7704 8.6502 16.7704 9.16797V15.8342C16.7704 17.5797 15.3567 18.9946 13.6113 18.9946H6.38837C4.64307 18.9943 3.22919 17.5796 3.22919 15.8342Z"
          fill={color}
        />
        <path
          d="M17.1178 6.94678C17.1177 6.85102 17.0402 6.77344 16.9445 6.77344H3.0553C2.95963 6.77358 2.8821 6.85111 2.88196 6.94678V8.05762C2.88196 8.15341 2.95954 8.23203 3.0553 8.23218H16.9445C17.0403 8.23218 17.1178 8.1535 17.1178 8.05762V6.94678ZM18.9928 8.05762C18.9928 9.18903 18.0759 10.1072 16.9445 10.1072H3.0553C1.92401 10.107 1.00696 9.18894 1.00696 8.05762V6.94678C1.0071 5.81558 1.9241 4.89858 3.0553 4.89844H16.9445C18.0758 4.89844 18.9927 5.81549 18.9928 6.94678V8.05762Z"
          fill={color}
        />
      </svg>
    );
  },
);

GiftBoxIcon.displayName = "GiftBoxIcon";

interface GiftIconProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

export const GiftIcon = forwardRef<SVGSVGElement, GiftIconProps>(
  ({ color = "white", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        fill={color}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="66"
        height="72"
        viewBox="0 0 66 72"
        aria-hidden="true"
      >
        <path
          d="M32.8436 42.6149V28.235L19.4008 22.3494V36.7293L32.8436 42.6149Z"
          fill="#94B9F6"
        />
        <path
          d="M0 13.8551V28.235L3.12796 29.6045L14.7014 34.6718V27.4818V20.2918L0 13.8551Z"
          fill="#94B9F6"
        />
        <path
          d="M19.4008 22.3494L32.8436 28.235L46.4144 22.3494L32.8436 16.356L19.4008 22.3494Z"
          fill="#B3CEFA"
        />
        <path
          d="M12.9208 9.67375L0 13.8551L14.7014 20.2918L22.8341 16.356C19.6739 15.7817 14.4072 13.6162 12.9208 9.67375Z"
          fill="#B3CEFA"
        />
        <path
          d="M17.5072 8.18954C18.8529 10.7857 25.3748 12.4405 28.7773 12.6045C27.1663 10.4575 24.8061 8.03229 22.64 6.5285L17.5072 8.18954Z"
          fill="#B3CEFA"
        />
        <path
          d="M37.9332 4.85799L32.8436 3.22647L28.0358 4.78235C29.832 6.30973 31.4942 7.9922 32.8436 9.47839C34.1534 8.08583 35.9339 6.4104 37.9332 4.85799Z"
          fill="#B3CEFA"
        />
        <path
          d="M38.4739 12.6045C41.7994 12.1407 47.5592 10.7062 49.4431 8.5476L44.3126 6.90298C42.1755 8.46779 39.9351 10.7916 38.4739 12.6045Z"
          fill="#B3CEFA"
        />
        <path
          d="M51.6114 20.0954L66 13.8551L54.0677 10.0301C51.997 13.275 47.3512 15.5771 44.1043 16.356L51.6114 20.0954Z"
          fill="#B3CEFA"
        />
        <path
          d="M32.8436 42.6149L46.528 36.68L46.4144 22.3494L32.8436 28.235V42.6149Z"
          fill="#709ADF"
        />
        <path
          d="M66 28.235V13.8551L51.6114 20.0954V34.4754L62.872 29.5916L66 28.235Z"
          fill="#709ADF"
        />
        <path
          d="M51.6114 20.0954L46.4144 22.3494L46.528 36.68L51.6114 34.4754V20.0954Z"
          fill="#246CE1"
        />
        <path
          d="M47.2322 65.7088L51.6114 63.7941V37.7148V34.4754L46.528 36.68L46.5535 39.9045L46.7596 65.9154L47.2322 65.7088Z"
          fill="#246CE1"
        />
        <path
          d="M19.4008 22.3494L14.7014 20.2918V27.4818V34.6718L19.4008 36.7293V22.3494Z"
          fill="#367EF4"
        />
        <path
          d="M14.7014 63.9841L19.4008 66.0605V39.9589V36.7293L14.7014 34.6718V37.903V63.9841Z"
          fill="#367EF4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.7014 20.2918L19.4008 22.3494L32.8436 16.356L46.4144 22.3494L51.6114 20.0954L44.1043 16.356C47.3512 15.5771 51.997 13.275 54.0677 10.0301C55.3217 8.06497 55.6313 5.75411 54.1137 3.22647C50.5381 -2.72905 43.4138 0.602221 37.9332 4.85799C35.9339 6.4104 34.1534 8.08583 32.8436 9.47839C31.4942 7.9922 29.832 6.30973 28.0358 4.78235C23.0312 0.526846 17 -2 13.763 3.22647C12.2402 5.68524 12.2494 7.89293 12.9208 9.67375C14.4072 13.6162 19.6739 15.7817 22.8341 16.356L14.7014 20.2918ZM28.7773 12.6045C25.3748 12.4405 18.8529 10.7857 17.5072 8.18954C17.1199 7.44234 17.1614 6.61716 17.8294 5.7271C18.7388 4.51538 20.6036 5.11477 22.64 6.5285C24.8061 8.03229 27.1663 10.4575 28.7773 12.6045ZM49.4431 8.5476C47.5592 10.7062 41.7994 12.1407 38.4739 12.6045C39.9351 10.7916 42.1755 8.46779 44.3126 6.90298C46.5978 5.2297 48.7648 4.42432 49.7346 6.03971C50.285 6.95652 50.099 7.79596 49.4431 8.5476Z"
          fill="#478BFB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.8436 72V45.8398L46.5535 39.9045L46.7596 65.9154L32.8436 72Z"
          fill="#709ADF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M62.872 32.8398V58.8705L51.6114 63.7941V37.7148L62.872 32.8398Z"
          fill="#709ADF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.8436 45.8398L19.4008 39.9589V66.0605L32.8436 72V45.8398Z"
          fill="#94B9F6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.12796 58.8705V32.8398L14.7014 37.903V63.9841L3.12796 58.8705Z"
          fill="#94B9F6"
        />
        <path
          d="M14.7014 34.6718L3.12796 29.6045V32.8398L14.7014 37.903V34.6718Z"
          fill="#709ADF"
        />
        <path
          d="M32.8436 42.6149L19.4008 36.7293V39.9589L32.8436 45.8398V42.6149Z"
          fill="#709ADF"
        />
        <path
          d="M46.528 36.68L32.8436 42.6149V45.8398L46.5535 39.9045L46.528 36.68Z"
          fill="#5C84C6"
        />
        <path
          d="M62.872 29.5916L51.6114 34.4754V37.7148L62.872 32.8398V29.5916Z"
          fill="#5C84C6"
        />
      </svg>
    );
  },
);
GiftIcon.displayName = "GiftIcon";

interface GiftBoxAcceptedIconProps extends SVGProps<SVGSVGElement> {
  color?: string;
  title?: string;
}

export const GiftBoxAcceptedIcon = forwardRef<
  SVGSVGElement,
  GiftBoxAcceptedIconProps
>(({ color = "currentColor", title = "Gift Accepted Box", ...props }, ref) => {
  return (
    <svg
      ref={ref}
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <title>{title}</title>
      <path
        d="M13.8887 1.00781C15.4796 1.00796 16.7713 2.29876 16.7715 3.88965C16.7715 4.24371 16.7068 4.58305 16.5898 4.89648H16.9443C18.0757 4.89649 18.992 5.81402 18.9922 6.94531V8.05566C18.9922 9.18708 18.0758 10.1055 16.9443 10.1055H16.7705V15.834C16.7704 17.5793 15.3567 18.994 13.6113 18.9941H6.38867C4.64344 18.9938 3.22959 17.5793 3.22949 15.834V10.1055H3.05469C1.92362 10.1051 1.00684 9.18683 1.00684 8.05566V6.94531C1.00698 5.81427 1.92371 4.89689 3.05469 4.89648H3.41016C3.29321 4.58307 3.22951 4.24369 3.22949 3.88965C3.22963 2.29867 4.52031 1.00781 6.11133 1.00781C8.03043 1.00796 9.24931 2.31478 9.92676 3.38965C9.9514 3.42875 9.97544 3.46785 9.99902 3.50684C10.0226 3.4678 10.0476 3.42881 10.0723 3.38965C10.7497 2.31472 11.9694 1.00798 13.8887 1.00781ZM13.7588 9.02246C13.4255 8.6728 12.8713 8.65905 12.5215 8.99219L8.96484 12.3779L7.76855 11.0811C7.44084 10.7261 6.88634 10.7037 6.53125 11.0312C6.17635 11.3589 6.15408 11.9134 6.48145 12.2686L8.28223 14.2197C8.44102 14.3917 8.66258 14.4932 8.89648 14.501C9.13065 14.5085 9.35857 14.4212 9.52832 14.2598L13.7285 10.2598C14.0784 9.9265 14.092 9.3724 13.7588 9.02246ZM6.11133 2.88281C5.55585 2.88281 5.10463 3.3342 5.10449 3.88965C5.10457 4.44515 5.55581 4.89746 6.11133 4.89746H8.625C8.54159 4.73243 8.44875 4.55944 8.3418 4.38965C7.79402 3.52041 7.06818 2.88296 6.11133 2.88281ZM13.8887 2.88281C12.9319 2.88298 12.2069 3.52051 11.6592 4.38965C11.5521 4.55966 11.4575 4.73221 11.374 4.89746H13.8887C14.4441 4.89731 14.8964 4.44506 14.8965 3.88965C14.8963 3.33429 14.444 2.88296 13.8887 2.88281Z"
        fill={color}
      />
    </svg>
  );
});

GiftBoxAcceptedIcon.displayName = "GiftBoxAcceptedIcon";
